var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "insta",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M12,2c2.717,0,3.056.01,4.122.06a7.367,7.367,0,0,1,2.428.465,4.876,4.876,0,0,1,1.772,1.153A4.908,4.908,0,0,1,21.475,5.45a7.387,7.387,0,0,1,.465,2.428C21.987,8.944,22,9.283,22,12s-.01,3.056-.06,4.122a7.393,7.393,0,0,1-.465,2.428,5.106,5.106,0,0,1-2.925,2.925,7.387,7.387,0,0,1-2.428.465c-1.066.047-1.4.06-4.122.06s-3.056-.01-4.122-.06a7.393,7.393,0,0,1-2.428-.465A5.106,5.106,0,0,1,2.525,18.55a7.361,7.361,0,0,1-.465-2.428C2.013,15.056,2,14.717,2,12s.01-3.056.06-4.122A7.361,7.361,0,0,1,2.525,5.45,4.88,4.88,0,0,1,3.678,3.678,4.9,4.9,0,0,1,5.45,2.525,7.361,7.361,0,0,1,7.878,2.06C8.944,2.013,9.283,2,12,2Zm0,5a5,5,0,1,0,5,5A5,5,0,0,0,12,7Zm6.5-.25A1.25,1.25,0,1,0,17.25,8,1.25,1.25,0,0,0,18.5,6.75ZM12,9a3,3,0,1,1-3,3A3,3,0,0,1,12,9Z",
    fill: "#818181"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.543337dfdeb60aadfeae464e74112fe5.svg";
export { ForwardRef as ReactComponent };